import { render, staticRenderFns } from "./api_access.vue?vue&type=template&id=58779fae&scoped=true&"
import script from "./api_access.vue?vue&type=script&lang=js&"
export * from "./api_access.vue?vue&type=script&lang=js&"
import style0 from "./api_access.vue?vue&type=style&index=0&id=58779fae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58779fae",
  null
  
)

export default component.exports